/* eslint-disable no-unused-vars */
import { Notification } from 'element-ui'
import {
  login,
  logout
} from '@/api/user'
import { sha256 } from 'js-sha256'
import {
  getRsaKeys,
  decryptData
} from '@/utils/jsencrypt-util'
import {
  getToken,
  setToken,
  removeToken,
  getSessionId,
  setSessionId,
  removeSessionId
} from '@/utils/auth'
import router, { resetRouter } from '@/router'
import { portalType } from '@/setting'
import {
  getNowFormatDate,
  getTimezoneOffset
} from '@/utils/index'
import { tryHideFullScreenLoading } from '@/utils/loading'

// 声明状态
const state = {
  token: '',
  sessionID: ''
}

// 修改状态
const mutations = {
  /**
   * 设置会话token
   * @param {Object} state 状态对象
   * @param {String} token 会话token
   */
  SET_TOKEN: (state, token) => {
    state.token = token
  },

  /**
   * 设置session id
   * @param {Object} state 状态对象
   * @param {String} value session id
   */
  SET_SESSION_ID: (state, value) => {
    state.sessionId = value
  }
}

const actions = {
  login ({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      const { username, password, organizationCode } = userInfo
      window.sessionStorage.setItem('username', username)
      // 登录方法1，由FE生成RSA密钥，并将密钥及加密信息一同发送
      // getRsaKeys().then(res => {
      //   const { privateKey, publicKey } = res
      //   const encodedPassword = sha256(password + username)
      //   const loginInfo = {
      //     PortalType: portalType,
      //     OrganizationCode: organizationCode,
      //     UserCode: username,
      //     EncodedPassword: encodedPassword,
      //     PublicKey: publicKey,
      //     RequestTime: getNowFormatDate().UTCDate.format1,
      //     TimeZoneOffsetSecond: getTimezoneOffset(),
      //     // TODO: 多语言功能，目前默认显示中文CN
      //     Lang: 'cn'
      //   }
      //   login(loginInfo).then(response => {
      //     const { EncodedToken, SessionId } = response
      //     let token = decryptData(privateKey, EncodedToken)
      //     token = trimDecryData(token)
      //     commit('SET_TOKEN', token)
      //     setToken(token)
      //     setSessionId(SessionId)
      //     resolve(response)
      //   }).catch(error => {
      //     reject(error)
      //   })
      // }).catch()

      // 登录方法2，不生成RSA密钥，除密钥信息外发出
      const loginInfo = {
        PortalType: portalType,
        OrganizationCode: organizationCode,
        UserCode: username,
        EncodedPassword: sha256(password + username),
        RequestTime: getNowFormatDate().UTCDate.format1,
        TimeZoneOffsetSecond: getTimezoneOffset(),
        // TODO: 多语言功能，目前默认显示中文CN
        Lang: 'cn'
      }
      login(loginInfo).then(response => {
        const { Secret, SessionId } = response
        let token = Secret
        token = trimDecryData(token)
        commit('SET_TOKEN', token)
        setToken(token)
        setSessionId(SessionId)
        tryHideFullScreenLoading()
        resolve(response)
      }).catch(error => {
        tryHideFullScreenLoading()
        reject(error)
      })
    })
  },

  logout ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        removeSessionId()
        // resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      removeSessionId()
      resolve()
    })
  }
}

function trimDecryData (data) {
  let token = ''
  if (data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].charCodeAt() !== 0) {
        token += data[i]
      }
    }
  }
  return token
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js